import React from "react";
import { Card, Button, PageHeader, Descriptions, Row, Col, Statistic, Form, Input, Select } from "antd";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";
import { FrTypes, FrStatus } from "../../common/Fr";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";
import { FundraisingDlg } from "./components/FundraisingDlg";
import { DonateTable } from "./components/DonateTable";
import { DonateTable2 } from "./components/DonateTable2";
import { PerGoalAchievedDlg } from "./components/PerGoalAchievedDlg";

export const Fundraiser = observer(() => {
  let { id } = useParams<any>();
  const { fundEdit, fundView } = Store.fundsStore;
  fundView.active(id);

  return (
    <div>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={fundView.fund?.name}
        extra={[
          Store.isDivision ? undefined : (
            <Button size="small" key="3" onClick={() => fundEdit.edit(id)}>
              Edit
            </Button>
          ),
        ]}
      >
        <div className="content" style={{ display: "flex" }}>
          <div className="main">
            <Descriptions size="small" column={2}>
              <Descriptions.Item label="Type">{FrTypes[fundView.fund?.type || 0]}</Descriptions.Item>
              <Descriptions.Item label="Organizer">
                {fundView.fund?.org?.name} / {fundView.fund?.funOrg?.name}
              </Descriptions.Item>
              <Descriptions.Item label="Time Duration">
                {moment(fundView.fund?.start).format("MMM D. YYYY")} -{" "}
                {moment(fundView.fund?.end).format("MMM D. YYYY")}
              </Descriptions.Item>
              <Descriptions.Item label="Creation Time">
                {moment(fundView.fund?.createDate).format("YYYY-MM-DD HH:mm:ss")}
              </Descriptions.Item>
              <Descriptions.Item label="Description" span={2}>
                {fundView.fund?.description}
              </Descriptions.Item>
              <Descriptions.Item label="Proceeds" span={2}>
                {fundView.fund?.proceeds}
              </Descriptions.Item>
            </Descriptions>
          </div>
          <div className="extra">
            <div
              style={{
                display: "flex",
                width: "max-content",
                justifyContent: "flex-end",
              }}
            >
              <Statistic title="Status" value={FrStatus[(fundView.fund?.state || 0) + 1]} style={{ marginRight: 32 }} />
              {/* <Statistic title="Historic" prefix="$" value={fundraiser?.historic} style={{ marginRight: 32 }} /> */}
              {/* <Statistic title="Suggested" prefix="$" value={fundView.fund?.suggested} style={{ marginRight: 32 }} /> */}
              <Statistic title="Target" prefix="$" value={fundView.fund?.target} style={{ marginRight: 32 }} />
            </div>
          </div>
        </div>
      </PageHeader>

      <div style={{ margin: "15px 10px" }}>
        <Card size="small" className="fm-filter-bar" bodyStyle={{ paddingBottom: 0 }}>
          <Form size="small">
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item label="Name">
                  <Input
                    allowClear
                    value={fundView.query.name}
                    onChange={(e) => (fundView.query.name = e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Types of donors">
                  <Select value={fundView.query.type} onChange={(e) => (fundView.query.type = e)}>
                    {fundView.types.map((x: any) => (
                      <Select.Option value={x.id} key={x.id}>
                        {x.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8} style={{ textAlign: "right" }}>
                <Button onClick={() => fundView.onSearch()}>Search</Button>
                <Button loading={fundView.exporting} onClick={() => fundView.onExport()}>
                  Download
                </Button>
                {fundView.isPerGoal && (
                  <Button
                    loading={fundView.saving}
                    disabled={fundView.fund?.complete}
                    onClick={() => {
                      fundView.showGoalsAchievedDlg = true;
                    }}
                  >
                    Save Goals Achieved
                  </Button>
                )}
                {fundView.isPerGoal && (
                  <Button
                    disabled={!fundView.canPerGoalComplete}
                    loading={fundView.saving2}
                    onClick={() => fundView.completePerGoal()}
                  >
                    Complete
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        </Card>

        {fundView.isPerGoal ? <DonateTable2></DonateTable2> : <DonateTable></DonateTable>}
      </div>

      <FundraisingDlg></FundraisingDlg>
      <PerGoalAchievedDlg />
    </div>
  );
});
